export default __webpack_public_path__ + "static/SourceCodePro.normal-88539bd3191f7f543b1135eaf9a11774.woff2";